function gendered(male, female = male, other = male) {
  return { male, female, other };
}

export function localizedGenderNode(male, female = male) {
  const fallback = Array.isArray(male) ? [...male] : male;
  return {
    he: gendered(male, female),
    en: fallback,
    es: fallback,
  };
}

export function titleNode(he, en = he, es = he) {
  return { he, en, es };
}

function continueCta() {
  return {
    primary: {
      label: { he: "המשך", en: "Continue", es: "Continuar" },
    },
  };
}

function finishCta() {
  return {
    primary: {
      label: { he: "עשיתי את זה", en: "I did it", es: "Lo hice" },
    },
  };
}

function textStep(id, body, ctas = continueCta()) {
  return {
    id,
    type: "text",
    body,
    ctas,
  };
}

function audioStep(id, body) {
  return {
    id,
    type: "audio",
    body,
    ctas: continueCta(),
  };
}

function writingStep(id, prompts) {
  return {
    id,
    type: "writing",
    body: {
      he: [],
      en: [],
      es: [],
    },
    prompts,
    ctas: continueCta(),
  };
}

function splitPromptNode(idBase, promptsNode) {
  const heMale = Array.isArray(promptsNode?.he?.male) ? promptsNode.he.male : [];
  const heFemale = Array.isArray(promptsNode?.he?.female) ? promptsNode.he.female : heMale;
  const en = Array.isArray(promptsNode?.en) ? promptsNode.en : heMale;
  const es = Array.isArray(promptsNode?.es) ? promptsNode.es : heMale;

  return heMale.map((prompt, index) =>
    writingStep(`${idBase}_${index + 1}`, {
      he: gendered(prompt, heFemale[index] || prompt),
      en: en[index] || prompt,
      es: es[index] || prompt,
    })
  );
}

export function buildNormalizedDay({
  dayNumber,
  title,
  emotionalStage,
  opening,
  mindfulness,
  prompts,
  closing,
  action,
}) {
  const dayId = String(dayNumber).padStart(2, "0");
  return {
    dayNumber,
    emotionalStage,
    title: titleNode(title),
    subtitle: titleNode(""),
    titleLine: titleNode(title),
    screens: [
      textStep(`d${dayId}_opening`, opening),
      audioStep(`d${dayId}_mindfulness`, mindfulness),
      ...splitPromptNode(`d${dayId}_writing`, prompts),
      textStep(`d${dayId}_closing`, closing),
      textStep(`d${dayId}_action`, action, finishCta()),
    ],
  };
}

export function buildNormalizedPilotBlueprint({
  id,
  problemKey,
  category,
  journeyName,
  days,
  durationDays = days.length,
  version = "normalizer_pilot_v1",
}) {
  return {
    id,
    version,
    totalDays: durationDays,
    durationDays,
    problemKey,
    journeyKey: problemKey,
    category,
    phase1: true,
    journeyName,
    ui: {
      phaseOneMode: true,
      wholeDayMode: false,
      showStageIndicators: false,
      showProgressText: false,
      primaryCtaDefault: "המשך",
      secondaryCtaDefault: "דילוג",
      allowSkipAlways: false,
      allowBack: true,
      hideDayCount: false,
      entryLabel: { he: "היום", en: "Today", es: "Hoy" },
    },
    days,
    languages: {
      he: { days },
      en: { days },
      es: { days },
    },
  };
}
